export default "__VITE_PUBLIC_ASSET__59be3bc4__"